import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { MedicineDetailsModalOpenAction, MedicineName } from '~libs.desktop.shared.medicine';

type MedicineHeadingProps = Pick<PatientMedicine, 'medicine' | 'reimbursements'> & {
   readonly confirmationButtonLabel?: string;
   readonly onConfirm?: VoidFunction;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const MedicineHeading = (props: MedicineHeadingProps): JSX.Element => {
   return (
      <MedicineDetailsModalOpenAction
         medicine={props.medicine}
         reimbursements={props.reimbursements}
         confirmationButtonLabel={props.confirmationButtonLabel}
         onConfirm={props.onConfirm}
         visitDiagnoses={props.visitDiagnoses}
         render={(openModal) => (
            <MedicineName name={props.medicine.fullName} atc={props.medicine.atc} onClick={openModal} />
         )}
      />
   );
};
